export function IconFacebook(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 13 25" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M8.584 24.133v-10.5h3.5l.667-4.343H8.584V6.47c0-1.188.582-2.346 2.448-2.346h1.895V.427S11.207.133 9.564.133c-3.432 0-5.676 2.08-5.676 5.847v3.31H.073v4.343h3.815v10.5h4.696z"
        fill="currentColor"
        fillRule="nonzero"
      />
    </svg>
  );
}
